jQuery(document).ready(() => {
    remove_release_notes_cookies_if_on_login();
    update_unseen_release_notes_counter();
    release_notes_cache_cleanup_time_left();
});
function open_release_notes() {
    const $ = jQuery.noConflict();
    let isLoading = false;
    $('.release-notes-wrapper').remove();
    let div = $('<div class="release-notes-wrapper"></div>');
    div.append('<div class="close-button-wrapper"><a href="#" class="close-button">&times;</a></div>');
    div.append('<h1>Release notes</h1>');
    const ul = $('<ul></ul>');
    const listWrapper = $('<div class="list-wrapper"></div>');
    listWrapper.html(ul);
    div.append(listWrapper);

    $('body').prepend(div);

    setTimeout(() => {
        div.addClass('show');
    }, 50);

    div.find('.close-button-wrapper a').click(() => {
        const duration = parseFloat(div.css('transition-duration')) * 1000;
        div.removeClass('show');
        setTimeout(() => {
            div.remove();
        }, duration);
        return false;
    });


    let releaseNotes = getCookie('releaseNotes');
    if (!releaseNotes) {
        load_notes((releaseNotes) => draw_release_notes(releaseNotes));
    } else {
        draw_release_notes(releaseNotes);
    }

    function unset_scroll_event() {
        listWrapper.unbind('scroll');
    }
    function set_scroll_event_to_load_more_notes() {
        listWrapper.unbind('scroll').scroll(() => {
            if (isLoading) {
                return;
            }
            const height = listWrapper.outerHeight();
            const scrollPosition = listWrapper.scrollTop();
            const scrollHeight = ul.outerHeight() - height;

            const lastLiHeight = ul.find('li:last').height();
            if (scrollHeight - scrollPosition < lastLiHeight) {
                isLoading = true;
                const page = parseInt(getCookie('releaseNotesPage', 1));
                setCookie('releaseNotesPage', (page + 1), release_notes_cache_cleanup_time_left());
                load_notes((releaseNotes) => draw_release_notes(releaseNotes));
            }
        });
    }

    function draw_release_notes(releaseNotes) {
        const ul = div.find('ul');

        ul.find('li:not([data-id])').remove();
        if (get_unread_release_notes_count_from_screen() > 0) {
            const firstLi = $('<li></li>');
            const a = $('<a href="#">Alles gelezen markeren</a>');
            a.click(() => {
                $.post('/release-notes/allSeen');
                releaseNotes.forEach((releaseNote) => {
                    releaseNote.seen = true;
                });
                setCookie('releaseNotes', releaseNotes, release_notes_cache_cleanup_time_left());
                set_unread_release_notes_count_on_screen(0);
                draw_release_notes(releaseNotes);
                firstLi.remove();
                return false;
            });
            firstLi.append(a);
            ul.prepend(firstLi);
        }

        releaseNotes.forEach((releaseNote) => {
            const li = $('<li data-id="' + releaseNote.id + '"></li>');
            li.toggleClass('seen', releaseNote.seen);
            li.append('<span>' + releaseNote.date + '</span>');
            const div = $('<div></div>');
            div.append('<h2>' + releaseNote.title + '</h2>');
            div.append('<p>' + releaseNote.excerpt + '</p>');
            li.append(div);
            ul.find('[data-id="' + releaseNote.id + '"]').remove();

            div.click(() => {
                const page = $('<div class="single-release-note"></div>');
                page.append('<h1>' + releaseNote.title + '</h1>');
                page.append('<div class="contents">' + releaseNote.content + '</div>');
                page.append('<div class="text-center"><a class="button primary">Sluiten</a></div>');

                if (!releaseNote.seen) {
                    releaseNote.seen = true;
                    setCookie('releaseNotes', releaseNotes, release_notes_cache_cleanup_time_left());
                    $.post('/release-notes/seen/' + releaseNote.id);
                    li.toggleClass('seen', releaseNote.seen);
                    update_unseen_release_notes_counter(false);
                }

                foundationPopup(page, (elm, popup) => {
                    page.find('a').click(() => {
                        popup.close();
                        return false;
                    });
                });
            });

            ul.append(li);
        });

        const gotAll = getCookie('gotAllReleaseNotes', false);
        if (!gotAll) {
            set_scroll_event_to_load_more_notes();
        } else if (gotAll) {
            unset_scroll_event();
        }
    }

    function load_notes(cb) {
        isLoading = true;
        const page = getCookie('releaseNotesPage', 1);
        $.get('/release-notes?page=' + page, (notes) => {
            isLoading = false;
            if (!notes.data || notes.data.length === 0) {
                setCookie('gotAllReleaseNotes', true);
                unset_scroll_event();
                return;
            }
            setCookie('releaseNotesPage', parseInt(page), release_notes_cache_cleanup_time_left());
            const gotAllNotes = parseInt(page) === parseInt(notes.last_page);
            setCookie('gotAllReleaseNotes', gotAllNotes, release_notes_cache_cleanup_time_left());
            releaseNotes = typeof releaseNotes === 'object' ? releaseNotes : [];
            releaseNotes = releaseNotes.concat(notes.data);
            setCookie('releaseNotes', releaseNotes, 1);

            if (gotAllNotes) {
                unset_scroll_event();
            }
            if (cb) {
                cb(notes.data);
            }
        });
    }

    return false;
}

function release_notes_cache_cleanup_time_left() {
    const firstSync = 8;
    const secondSync = 13;

    const now = new Date();

    const target = new Date();
    target.setHours(firstSync);
    if (target < now) {
        target.setHours(secondSync);

        if (target < now) {
            target.setHours(firstSync + 24);
        }
    }
    const diff = Math.abs((target.getTime() - now.getTime()) / 1000);


    const secondsInDay = 24 * 60 * 60;
    return diff / secondsInDay;
}

function update_unseen_release_notes_counter(ajax = true) {
    const $ = jQuery.noConflict();
    const icon = $('.top-bar-wrapper').find('.visual-icon-bell');
    if (icon.length === 0) {
        return;
    }
    if (ajax) {
        const count = getCookie('unreadReleaseNotesCount', -1);
        if (parseFloat(count) < 0) {
            $.get('/release-notes/getUnreadReleaseNotesCount', (data) => {
                set_unread_release_notes_count_on_screen(data);
                setCookie('unreadReleaseNotesCount', data, release_notes_cache_cleanup_time_left());
            });
        } else {
            set_unread_release_notes_count_on_screen(count);
        }
    } else {
        const newValue = get_unread_release_notes_count_from_screen() - 1;
        setCookie('unreadReleaseNotesCount', newValue, release_notes_cache_cleanup_time_left());
        set_unread_release_notes_count_on_screen(newValue);
    }
}
function set_unread_release_notes_count_on_screen(value) {
    const $ = jQuery.noConflict();
    const icon = $('.top-bar-wrapper').find('.visual-icon-bell');

    value = parseInt(value);
    if (value < 1) {
        value = 0;
    }
    icon.attr('notification-number', value);
}
function get_unread_release_notes_count_from_screen() {
    const $ = jQuery.noConflict();
    const icon = $('.top-bar-wrapper').find('.visual-icon-bell');
    let number = parseInt(icon.attr('notification-number'));
    if (number < 1) {
        number = 0;
    }
    return number;
}
function remove_release_notes_cookies_if_on_login() {
    if (window.location.href.split('/login').length === 2) {
        ['gotAllReleaseNotes', 'releaseNotesPage', 'releaseNotes', 'unreadReleaseNotesCount'].forEach((name) => {
            setCookie(name, null, -1);
        });
    }
}